import { FC, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { endpoints } from "../../../ApiEndPoints/apiEndPoints";
import { initialValueOfProductModel } from "../../../Models/ProductModel";
import { storeDataTablePayload } from "../../../Redux/Actions/dataTableActions";
import { storeFilter } from "../../../Redux/Actions/filterActions";
import store from "../../../Store/store";
import { DataTableType } from "../../../Types/editableFamilyGroupType";
import { filterPayloadType } from "../../../Types/filterPayloadType";
import { IColumn } from "../../../Types/gridDataProps";
import { filterFormatterAsPerModel } from "../../../helpers/filterFormatterAsPerModelHelper";
import { menuHeaderPayload } from "../../../Redux/Actions/menuHeaderAction";

const Summary: FC<DataTableType> = (props: DataTableType) => {
  const history = useHistory();
  const user = useSelector((state: any) => state.auth.user);

  const IsProductCountZero = (event: any): boolean => {
    return event["TotalRecords"] === 0;
  };
  let parentData = useSelector((state: any) => state.filterReducer);
  const parentName = parentData ? parentData.data.parentName : "";

  const routeToProduct = (event: any) => {
    let searchId = event["FamilyGroup"]; //.split(' - ')[0];
    let description = event["Description"]; //.split(' - ')[0];
    let filterObject = {
      FamilyGroup: searchId,
      BusinessUnit: event["BusinessUnit"],
      SuperCategory: event["SuperCategory"],
      Category: event["Category"],
      SubCategory: event["SubCategory"],
      Segment: event["Segment"],
    };
    let data = filterFormatterAsPerModel(
      filterObject,
      initialValueOfProductModel
    );

    let filterPayload: filterPayloadType = {
      data: data,
      isDirectQuery: false, //since this is redirection that's why false
      codeScreen: "",
      parentName: parentName,
      selectedMenu: "Query",
      searchId: searchId,
      description: description,
      createPopupName: undefined,
      deletePopupName: undefined,
      nestedSearchId: undefined,
      previousParentName: undefined,
      previousQueryData: data,
      searchPageReset: undefined,
    };
    store.dispatch(menuHeaderPayload(null));
    store.dispatch(storeFilter(filterPayload));
    history.push({
      pathname: "/product/query",
      state: {
        // Location state
        id: searchId,
      },
    });
  };

  const columnDefinition: IColumn[] = [
    {
      name: "Business Unit",
      accessor: "BusinessUnitDesc",
    },
    {
      name: "Super Cat",
      accessor: "SuperCatDesc",
    },
    {
      name: "Category",
      accessor: "CategoryDesc",
    },
    {
      name: "Sub Cat",
      accessor: "SubCategoryDesc",
    },
    {
      name: "Segment",
      accessor: "SegmentDesc",
    },
    {
      name: "Product Group",
      accessor: "ProductType",
    },
    {
      name: "Family Group",
      accessor: "FamilyGroup",
      type: "family-group",
    },
    {
      name: "Item Count UOM",
      accessor: "TotalRecords",
      type: "link",
      disableCriteria: (event: any) => IsProductCountZero(event),
      onClick: (event: any) => {
        routeToProduct(event);
      },
    },
    {
      name: "Created Date",
      accessor: "CreatedDate",
      customClass: { td: "no-wrap" },
    },
    {
      name: "Last Updated Date",
      accessor: "UpdatedDate",
      customClass: { td: "no-wrap" },
    },
    {
      name: "Last Updated By",
      accessor: "UpdatedBy",
    },
  ];

  if (user?.isLDMService) {
    columnDefinition.push({
      name: "",
      accessor: "",
      type: "btn",
      btnType: "edit",
    });
  }

  useEffect(() => {
    let payload = {
      service: endpoints.getFamilyGroupAdminView(),
      columnDefinition: columnDefinition,
      toggleSearchPanel: (e: any) => props.toggleSearchPanel(e),
      isColumnMerge: true,
      isPaginationRequired: true,
    };
    store.dispatch(storeDataTablePayload(payload));
  }, []);

  return <></>;
};

export default Summary;
